// extracted by mini-css-extract-plugin
export var sectionTitle = "area-selection-section-module--sectionTitle--1ZLSV";